<script>
import liff from "@line/liff";
export default {
	name: "Maintenance",
	methods: {
		closeLiff() {
			liff.closeWindow();
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped></style>
